//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    methods: {
        preview (e) {
            const { img } = e.currentTarget.dataset
            this.$router.push({
                path:`/building/material/preview?url=${encodeURIComponent(img)}`
            })
        }
    }
}
